import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgUpload = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7929 9.41421V20H9.79289L9.79289 9.41421L5.5 13.7071L4.08579 12.2929L10.7929 5.58579L17.5 12.2929L16.0858 13.7071L11.7929 9.41421ZM19 3.79289L3 3.79289V1.79289L19 1.79289V3.79289Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgUpload);

export default ForwardRef;
